import React from "react";
import "../Logos.css";
import { uploadLogoDetails, getDefalutLogos } from "../../../../../../Redux/actions/projectActions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { SHA256 } from "crypto-js";
import { RxWidth } from "react-icons/rx";
import { uploadFileToS3 } from "../../../../../../services/axios";
import CustomToast from "../../../../../../Components/CustomToast/CustomToast";
import { customToatStyle } from "../Logos";

const OVERLAY_STYLES = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 1000,
};

const MODAL_STYLES = {
  position: "fixed",
  top: "35%",
  left: window.innerWidth > 1600 ? "41%" : "35%",
  transform: "translate(-50%, -50%)",
  padding: "50px",
  zIndex: 1000,
  border: "1px solid #ffffff33",
};

const UpdateLogoEdit = ({
  setIsUploadingModal,
  file,
  setFile,
  setReLoading,
  setAlertModal,
  currentBlockIdx,
}) => {
  const projectData = useSelector((state) => state.project?.credits);
  const dispatch = useDispatch();
  const isCard = JSON.parse(localStorage.getItem("isCard"));

  const handleNo = () => {
    setIsUploadingModal(false);
    setFile({});
  };

  const handleUploadLogo = async (file) => {
    console.log("2 Confirm upload logo Edit");
    if (
      file?.type !== "image/jpeg" &&
      file?.type !== "image/png" &&
      file?.type !== "image/jpg"
    ) {
      setAlertModal(true);
      return;
    } else {
      setIsUploadingModal(false);
      const creditID = projectData ? projectData[currentBlockIdx]?._id : "";
      const fileName = file.name + Date.now();
      const fileType = file.type;
      const fileArrayBuffer = await file.arrayBuffer();
      const fileUint8Array = new Uint8Array(fileArrayBuffer);
      const sha256Hash = SHA256(fileUint8Array).toString();
      if (!fileName || !fileType) {
        toast.error("File Not Selected");
        return;
      } else {
        await setReLoading({ condn: true, label: "Uploading..." });
        const fileBlob = new Blob([file], { type: fileType });
        const formData = new FormData();
        formData.append("fileName", fileName);
        formData.append("fileType", fileType);
        formData.append("creditID", creditID);
        formData.append("file", file);
        formData.append("shKey", sha256Hash);
        formData.append("isCard", isCard);

        const res = await dispatch(uploadLogoDetails(formData, creditID));        
        if (res?.success) {
          await dispatch(getDefalutLogos());
          toast(
            <CustomToast
              title=""
              content={"Logo uploaded successfully !"}
            />,
            customToatStyle
          );
          await setReLoading({ condn: false, label: "" });
        } 
        else {
          await setReLoading({ condn: false, label: "" });
          console.log(" Error ", res);
        }
      }
    }
  };

  return (
    <div className="logoEdit-container">
      <div className="logoEdit-overlay" />
      <div className="logoEdit-content p-4">
        <h2 className="manrope-800 text-[1.2rem] text-white mt-2">
          Please Confirm the following
        </h2>
        <p className="w-[25rem] manrope-400 mt-[1rem] text-[0.9rem]  text-white">
          By uploading my own custom logo, I acknowledge that I own{" "}
          <b>{file.name}</b> or have the right to use it for my intended
          purposes.
        </p>
        <div className="flex p-2 gap-4 justify-end mt-4 text-gray-900">
          <button className="updateLogoEditNoBtn" onClick={() => handleNo()}>
            Cancel
          </button>
          <button
            className="updateLogoEdit"
            onClick={() => handleUploadLogo(file)}
          >
            Yes, upload it!
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateLogoEdit;
